package com.eladfinish.bible.contest.screens.misc

data class MiscLinkItem(
    val text: String,
    val link: String,
)
